import { render, staticRenderFns } from "./exhibition-product-item.vue?vue&type=template&id=3a13e065&scoped=true&"
import script from "./exhibition-product-item.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-item.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-item.vue?vue&type=style&index=0&id=3a13e065&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13e065",
  null
  
)

export default component.exports